import authRules from '../authRules';

const addAssignmentViewActivityType = (user) => {
  const { activityType } = user.securityLevels;
  if (activityType >= authRules.addAssignmentViewActivityType.activityType) {
    return true;
  } else {
    return false;
  }
}

export default addAssignmentViewActivityType;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/addAssignmentViewActivityType.js